<template>
  <div>
    <div class="d-flex ml-2 mt-2" :class="isReply ? 'ml-2  ' : ''">
      <img
        v-if="opendetails"
        v-image
        class="img-details"
        :src="
          get(lastPostAs, 'type') === postedAsTypes.USER
            ? '/images/user.jpg'
            : get(lastPostAs, 'item.info.cropProfilePicture', '/empty.png')
        "
      />
      <img
        v-else
        v-image
        class="img"
        src="
          /empty.png
        "
      />

      <div class="width ml-1">
        <form @submit.prevent>
          <ion-input
            v-if="!opendetails"
            id="msgText"
            rows="3"
            class="c-input"
            :placeholder="`Title`"
            v-model="blabReply.title"
          />
          <ion-input v-else id="msgText" rows="3" class="c-input" :placeholder="`Title`" v-model="blabReply.title" />
          <div class="mt-2" v-if="!opendetails">
            <editor
              :key="rerenderEditorKey"
              :api-key="`${tinyMCEKey}`"
              :init="{
                height: 200,
                relative_urls: false,
                menubar: false,
                plugins:
                  'quickbars advlist autolink lists link image charmap preview anchor searchreplace visualblocks code insertdatetime media table code help wordcount',
                toolbar:
                  'undo redo | bold italic backcolor | blocks | fontfamily |  \
                   alignleft aligncenter alignright alignjustify | \
                   bullist numlist outdent indent | removeformat | help',
                contextmenu: false,
                quickbars_insert_toolbar: false,
                quickbars_selection_toolbar: 'bold italic underline strikethrough link',
              }"
              placeholder="Type your message here..."
              v-model="blabReply.text"
            />
          </div>

          <div class="mt-2" v-else>
            <editor
              :api-key="`${tinyMCEKey}`"
              :key="rerenderEditorKey"
              :init="{
                height: 250,
                relative_urls: false,
                menubar: false,
                plugins:
                  'quickbars advlist autolink lists link image charmap preview anchor searchreplace visualblocks code insertdatetime media table code help wordcount',
                toolbar:
                  'undo redo | bold italic backcolor | blocks | fontfamily |  \
                  alignleft aligncenter alignright alignjustify | \
                  bullist numlist outdent indent | removeformat | help',
                contextmenu: false,
                quickbars_insert_toolbar: false,
                quickbars_selection_toolbar: 'bold italic underline strikethrough link',
              }"
              placeholder="Type your message here..."
              v-model="blabReply.text"
            />
          </div>

          <div class="mt-2 d-flex">
            <div class="text-gray mt-1">
              Replying as
              <span :class="{ 'text-primary': !isPostAsUser }">{{ isPostAsUser ? 'yourself' : lastPostAsName }}</span
              >.
              <a href="#" @click.prevent="openPostAsList"
                ><b
                  >Reply as <i>{{ isPostAsUser ? 'your character' : 'yourself' }} instead!</i></b
                ></a
              >
            </div>
            <ion-button class="publish-btn d-flex ml-auto ml-5" @click="onPost" :disabled="!isValid">
              <span>Post</span>
            </ion-button>
          </div>
        </form>

        <post-as-select-modal
          :is-open="openPostAsModal"
          @dismiss-modal="closePostAsModal"
          @item-selected="selectPostAs"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import axios, { AxiosError } from 'axios';
import { Options, Vue } from 'vue-class-component';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import { toast } from '@/native';
import PostAsSelectModal from '@/modals/PostAsSelectModal.vue';
import Editor from '@/shared-components/Editor.vue';
import { blabReplyMessage, blabUserReplyMessage, editBlabReply } from '@/actions/blabs';
import { Prop, Watch } from 'vue-property-decorator';
import constants from '@/statics/constants';
import { authStore } from '~/pinia-store/auth';
import { mainStore } from '~/pinia-store/main';

@Options({
  name: 'PostChatMessage',
  components: { PostAsSelectModal, Editor },
})
export default class PostChatMessage extends Vue {
  @Prop({}) blab!: string;
  @Prop({ required: false }) blabEditingTitle!: string;
  @Prop({ required: false }) blabEditingText!: string;
  @Prop({ default: false }) isReply!: boolean;
  @Prop({}) parent!: string;
  @Prop({ default: false }) opendetails!: boolean;
  @Prop({ default: false }) isEdit!: boolean;
  @Prop({ default: false }) editId!: string;

  get = get;
  postedAsTypes = constants.postAsTypes;

  public get user() {
    const { user } = authStore();
    return user.value;
  }

  public get isAuthenticated() {
    const { isAuthenticated } = authStore();
    return isAuthenticated.value;
  }

  public get lastPostAsName() {
    const { lastPostAsName } = authStore();
    return lastPostAsName.value;
  }

  public get lastPostAs() {
    const { lastPostAs } = authStore();
    return lastPostAs.value;
  }

  public get isPostAsUser() {
    return !this.lastPostAs || this.lastPostAs.type === 'user';
  }

  public isPosting = false;
  public get windowWidth() {
    return window.innerWidth;
  }
  public get tinyMCEKey() {
    const {
      public: { tinyMCEKey },
    } = useRuntimeConfig();
    return tinyMCEKey;
  }

  public openPostAsModal = false;

  blabReply = {
    title: '',
    text: '',
    id: '',
  };

  public rerenderEditorKey = 0;
  public get dark() {
    const { dark } = mainStore();
    return dark.value;
  }

  @Watch('dark')
  public rerenderTextarea() {
    this.rerenderEditorKey = this.rerenderEditorKey + 1;
  }

  @Watch('isEdit')
  public onIsEditChanged(val: boolean = false) {
    if (val) {
      this.blabReply.title = this.blabEditingTitle;
      this.blabReply.text = this.blabEditingText;
    } else {
      this.blabReply.title = '';
      this.blabReply.text = '';
    }
  }

  mounted() {
    if (this.isEdit) {
      this.blabReply.title = this.blabEditingTitle || '';
      this.blabReply.text = this.blabEditingText || '';
    }
  }

  public async edit() {
    await editBlabReply(this.parent, {
      title: this.blabReply.title,
      text: this.blabReply.text,
    });
    await toast.show('Message updated', 'nonative', 'success');
    this.$emit('send', {
      id: this.parent,
      title: this.blabReply.title,
      text: this.blabReply.text,
    });
  }

  public async onPost() {
    const { lastPostAsName, lastPostAs } = authStore();
    if (this.isEdit) return this.edit();
    try {
      if (this.isReply) {
        if (lastPostAsName.value === this.user.username) {
          const resp = await blabUserReplyMessage(this.blab, this.blabReply.title, this.blabReply.text, this.parent);
          this.$emit('send', this.parent);
        } else {
          const resp = await blabReplyMessage(
            this.blab,
            this.blabReply.title,
            this.blabReply.text,
            lastPostAs.value.id,
            this.parent
          );

          this.$emit('send', this.parent);
        }
      } else {
        if (lastPostAsName.value === this.user.username) {
          const resp = await blabUserReplyMessage(this.blab, this.blabReply.title, this.blabReply.text);
          this.$emit('posted');
          this.$emit('count');
          this.$emit('open');
        } else {
          const resp = await blabReplyMessage(this.blab, this.blabReply.title, this.blabReply.text, this.lastPostAs.id);
          this.$emit('posted');
          this.$emit('count');
          this.$emit('open');
        }
      }

      await toast.show('Message sent successfully', 'nonative', 'success');
      this.blabReply.title = '';
      this.blabReply.text = '';
    } catch (_e) {
      if (axios.isAxiosError(_e)) {
        const ae = _e as AxiosError;
        if (ae.response?.status === 403) {
          toast.show('Please pick another identity to post under.', 'nonative', 'primary');
          return this.openPostAsList();
        }
      }
      toast.show('Cannot send message. Please try again.', 'nonative', 'danger');
    }
  }

  public selectPostAs(data: { id: string; type: string; item: {} }) {
    const { updateLastPostAs } = authStore();
    updateLastPostAs({
      lastPostAs: data,
      lastPostAsName:
        data.type === constants.postAsTypes.USER
          ? get(data.item, 'username', 'Unknown')
          : get(data.item, 'info.name', 'Unknown'),
    });
  }

  public openPostAsList() {
    if (this.isEdit) return toast.show('Cannot change identity while editing', 'nonative', 'primary');
    this.openPostAsModal = true;
  }

  public get isValid() {
    return !!this.blabReply.title;
  }

  public get actionName() {
    return this.isEdit ? 'Update' : 'Post';
  }

  public closePostAsModal() {
    this.openPostAsModal = false;
  }

  public async created() {
    const { updateLastPostAs, lastPostAsName, lastPostAs } = authStore();
    if (!lastPostAs.value || !lastPostAsName.value) {
      updateLastPostAs({
        lastPostAs: { id: this.user.id, type: constants.postAsTypes.USER, item: cloneDeep(this.user) },
        lastPostAsName: this.user.username,
      });
    }
  }
}
</script>

<style lang="sass" scoped>
.img
  width: 40px
  height: 40px
  border-radius: 40px
  border: solid gray 0.1px
  object-fit: cover

.img-details
  width: 50px
  height: 50px
  border-radius: 40px
  border: solid gray 0.1px
  object-fit: cover

.publish-btn
  width: 100px

.width
  width: 90% !important
</style>
